import React from "react";
import trans from "../../../../../utils";
import { Divider } from "antd";
import Dropfile from "../../../../Helpers/Dropzone/Dropzone";

export default function LayoutAttach({ page, addPOI }) {
	const type = () => {
		if (page === 1) {
			return "project";
		} else if (page === 2) {
			return "building";
		} else if (page === 3) {
			return "level";
		} else if (page === 4) {
			return "space";
		} else {
			return "project";
		}
	};
	return (
		<div style={{ paddingInline: "8px" }}>
			<div>
				<div
					style={{
						fontWeight: "600",
						fontSize: "20px",
						textTransform: "capitalize",
					}}
				>
					{trans(`${type()} layout`)}
				</div>
				<span style={{ color: "#42526E", fontSize: "12px", fontWeight: "500" }}>
					{trans(`Upload the ${type()} file first`)}
				</span>
			</div>
			<Divider style={{ margin: "16px 0" }} />
			<Dropfile
				type="maintenance"
				name="layout"
				single={true}
				totalfiles={1}
				projectSetup={true}
				addData={addPOI}
			/>
			{addPOI.errors.layout && (
				<div className="validation">{trans(addPOI.errors.layout)}</div>
			)}
			{addPOI.values.layout.length === 0 && !addPOI.errors.layout && (
				<div className="validation">{trans("Layout is required")}</div>
			)}
		</div>
	);
}
